import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_currency_by_currency_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { currency_id: number }): 
  Promise<{ result: { Id?: number, ShortLabel?: string } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.currency_id)) {
      $missingRequiredInParams.push('\'currency_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      currency_id: number    }) {
        if(isNil($inParams.currency_id)) {
          return true; 
        }
      return false;
    }
}
